export default {
  sideBar: {
    buttons: {
      edit: 'Toggle editing mode',
      createView: 'Create view',
      createPrivateView: 'Create private view',
    },
    loggedUsersCount: 'Active sessions',
    ordering: {
      popups: {
        success: 'The groups was reordered',
        error: 'Several groups wasn\'t reordered',
        periodicRefreshWasPausedWhileEditingGroups: 'Periodic refresh was paused while you are editing the groups bar',
        periodicRefreshWasPaused: 'Periodic refresh was paused',
        periodicRefreshWasResumed: 'Periodic refresh was resumed',
      },
    },
  },
  topbar: {
    customObjects: 'Custom objects',
  },
};
